import React, {useEffect, useState} from 'react'

interface ToggleButtonProps {
 initialState?: boolean
 checked?: boolean
 disabled?: boolean
 className?: string
 onBtnClass?: string
 btnClassName?: string
 labelClassName?: string
 label?: string
 onChange?: (newState: boolean) => void
}

const ToggleButton: React.FC<ToggleButtonProps> = ({
 initialState = false,
 checked,
 className,
 btnClassName,
 labelClassName,
 onBtnClass,
 disabled,
 label,
 onChange,
}) => {
 const isControlled = checked !== undefined
 const [internalOn, setInternalOn] = useState(initialState)
 const isOn = isControlled ? checked : internalOn

 useEffect(() => {
  if (!isControlled) {
   setInternalOn(initialState)
  }
 }, [initialState, isControlled])

 const handleToggle = () => {
  if (!disabled) {
   const newState = !isOn
   if (!isControlled) {
    setInternalOn(newState)
   }
   onChange?.(newState)
  }
 }

 return (
  <button
   onClick={handleToggle}
   className={`${className} relative inline-flex h-6 w-11 items-center rounded-full transition-colors duration-200 focus:outline-none ${
    isOn
     ? disabled
       ? `${onBtnClass} bg-[#80868C]`
       : `${onBtnClass} bg-[#4E83E4]`
     : disabled
     ? 'bg-[#F5F8FA] border border-[#CED8E0]'
     : 'bg-[#E6EBF0] border border-[#CED8E0]'
   }`}
   role='switch'
   aria-checked={isOn}
  >
   {label && (
    <span className={`${labelClassName}`}>{label}</span>
   )}
   <span
    className={`${btnClassName} inline-block h-4 w-4 transform rounded-full transition-transform duration-200 ${
     isOn
      ? 'translate-x-6 bg-white'
      : disabled
      ? 'translate-x-6 bg-[#C5CED6]'
      : 'translate-x-1 bg-[#33393D]'
    }`}
   />
  </button>
 )
}

export {ToggleButton}
